import {Box, Flex, Text, Title} from 'exsportia-components'
import {Formik, FormikConfig} from 'formik'
import {FC} from 'react'
import {object, string} from 'yup'

import {Button} from '../../ui/components/button/button'
import {Input} from '../../ui/components/input/input'
import {PhoneLoginProgress} from '../../ui/components/phone-login-progress/phone-login-progress'
import {useLocale} from '../../utils/i18n'

type PhoneLoginNameFormType = {
  firstName: string
  lastName: string
}

type PhoneLoginNameStepProps = {
  onNext: (data: {firstName: string; lastName: string}) => void
  onBack?: () => void
  initialData?: {firstName: string; lastName: string}
}

export const PhoneLoginNameStep: FC<PhoneLoginNameStepProps> = ({onNext, onBack, initialData}) => {
  const {l} = useLocale()

  const validationSchema = object().shape({
    firstName: string().required(l('required') || 'Required'),
    lastName: string().required(l('required') || 'Required'),
  })

  const handleSubmit: FormikConfig<PhoneLoginNameFormType>['onSubmit'] = (values) => {
    onNext({
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
    })
  }

  return (
    <Formik<PhoneLoginNameFormType>
      initialValues={initialData || {firstName: '', lastName: ''}}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({handleSubmit: formikSubmit}) => (
        <Box pb={'24px'}>
          <PhoneLoginProgress currentStep={1} />
          <Flex mb='8px'>
            <Title
              text={l('tellUsAboutYourself', {defaultMessage: 'Tell us about yourself'})}
              styleType='h2'
            />
          </Flex>
          <Flex mb='16px'>
            <Text
              text={
                l('whats_your_name_description', {
                  defaultMessage: 'What is your name? Please use your full legal name.',
                }) || 'What is your name? Please use your full legal name.'
              }
            />
          </Flex>
          <Box mb='16px'>
            <Input
              id='firstName'
              label={l('firstName', {defaultMessage: 'First name'})}
              placeholder={l('firstName', {defaultMessage: 'First name'})}
            />
          </Box>
          <Box mb='16px'>
            <Input
              id='lastName'
              label={l('lastName', {defaultMessage: 'Last name'})}
              placeholder={l('lastName', {defaultMessage: 'Last name'})}
            />
          </Box>
          <Flex mt='8px' gap='16px'>
            {onBack && (
              <Box style={{flex: 1}}>
                <Button
                  type='secondary'
                  onClick={onBack}
                >
                  {l('back', {defaultMessage: 'Back', caseAction: 'capitalize'})}
                </Button>
              </Box>
            )}
            <Box style={{flex: 1}}>
              <Button onClick={formikSubmit as any}>{l('next', {defaultMessage: 'Next'})}</Button>
            </Box>
          </Flex>
        </Box>
      )}
    </Formik>
  )
}
